import React, { useEffect, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { GrFormPrevious } from "react-icons/gr";
import { MdOutlineNavigateNext } from "react-icons/md";
import "../css/pagination.css";
import moment from "moment/moment";
import axios from "axios";
import { Server2 } from "../../redux/actions/auth/auth.actions";
import { BsCaretDownFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

const PER_PAGE = 25;

const SellerWithdraws = () => {
  const navigate = useNavigate()
  const [Data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [LikesPopup, setDetPopup] = useState({index: 0, type: false});

  const [q, setQ] = useState("");
  const list = [
    "approved",
    "pending",
    "rejected",
    "paid",
  ];
  function searchData() {

    return Data.filter((user) => {
      if (q === "") {
        return user;
      } else if (user?.status.toLowerCase().includes(q.toLowerCase())) {
        return user;
      } else if (user?.sellerId?.fname.toLowerCase().includes(q.toLowerCase())) {
        return user;
      }
    });
  }
  const fetchRequests = () => {
    var config = {
      method: "get",
      url: Server2 + "/admin/get-payment-requests",
    };
    axios(config)
      .then(function (response) {
        setLoading(false);
        response.data.sort(
          (b, c) => new Date(c.processedAt) - new Date(b.processedAt)
        );
        setData(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  // API'S Approved request
  const ApprovePayment = (e) => {
    const data = {
      id: e,
    };
    let config = {
      method: "post",
      url: Server2 + "/admin/approve-payment",
      data: data,
    };

    axios(config)
      .then(function (response) {
        fetchRequests();
        console.log(response.data, "i am res---");
      })
      .catch(function (error) {
        console.log(error, "error Delete User");
      });
  };

  // API'S Approved request
  const RejectPayment = (e) => {
    const data = {
      id: e,
    };
    let config = {
      method: "post",
      url: Server2 + "/admin/reject-payment",
      data: data,
    };

    axios(config)
      .then(function (response) {
        fetchRequests();
        console.log(response.data, "i am res---");
      })
      .catch(function (error) {
        console.log(error, "error Delete User");
      });
  };

  // API'S Approved request
  const markPaid = (e) => {
    const data = {
      id: e,
    };
    let config = {
      method: "post",
      url: Server2 + "/admin/mark-paid",
      data: data,
    };

    axios(config)
      .then(function (response) {
        fetchRequests();
        console.log(response.data, "i am res---");
      })
      .catch(function (error) {
        console.log(error, "error Delete User");
      });
  };

  useEffect(() => {	
    setLoading(true);
    fetchRequests();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //pagination function
  function handlePageClick({ selected: selectedPage }) {
    setCurrentPage(selectedPage);
  }

  const toTitleCase = (str) => {
    return str.replace(/\w\S*/g, (text) => {
      return text.charAt(0).toUpperCase() + text.substring(1).toLowerCase();
    });
  }

  //pagination
  const offset = currentPage * PER_PAGE;
  const currentPageData =
    Data.length === 0
      ? null
      : searchData()
          .slice(offset, offset + PER_PAGE)
          .map((request, index) => (
            <tbody key={index}>
              <tr>
                <td>
                  <div className="d-flex px-2 py-1 cursor-pointer" onClick={() => navigate(`/profile/${request?.sellerId?._id}`, { state: { item: request?.sellerId?._id } })}>
                    <div>
                      <img
                        src={
                          request.sellerId.profile_pic
                            ? request.sellerId.profile_pic
                            : "/img/upload-photo.png"
                        }
                        className="avatar avatar-sm me-3"
                        alt="user1"
                      />
                    </div>
                    <div className="d-flex flex-column justify-content-center">
                      <h6 className="mb-0 text-sm text-capitalize ">
                        {request.sellerId.fname}
                      </h6>
                      <p className="text-xs text-secondary mb-0">
                        {request.sellerId.email}
                      </p>
                    </div>
                  </div>
                  {
                    LikesPopup.type === true && LikesPopup.index === index ?
                      <div style={{
                        position: "absolute",
                        marginLeft: "55px",
                        border: '1px solid',
                        backgroundColor: "#ffffff",
                        width: "140px",
                        height: "fit-content",
                        maxHeight: "150px",
                        borderRadius: "4px",
                        overflow: "auto",
                        zIndex: 100,
                        padding: "5px 5px",
                      }}>
                        <span style={{ color: "#000000", lineHeight: 0.7, marginbottom: "0px" }}>{request.bankDetails?.accountHolderName.toUpperCase()}</span><br />
                        <span style={{ color: "#000000", lineHeight: 0.7, marginbottom: "0px" }}>{request.bankDetails?.bankName}</span><br />
                        <span style={{ color: "#000000", lineHeight: 0.7, marginbottom: "0px" }}>{request.bankDetails?.accountNumber}</span><br />
                      </div>
                      :
                      null
                  }
                </td>
                <td className="align-middle text-center">
                  <p className={`fw-bold ${
                      request.walletSummary.availableBalance < request.amount && request.status !== "paid" ? "text-danger" : request.status !== "paid" ? "text-sucess" : "text-secondary"
                    }`}>{request.walletSummary.availableBalance.toFixed(2)}</p>
                </td>
                <td className="align-middle text-center">
                  <p className="text-secondary fw-bold ">{request.walletSummary.lockedAmount}</p>
                </td>
                <td className="align-middle text-center">
                  <p className="text-dark fw-bold">{request.amount}</p>
                </td>
                <td className="align-middle text-center">
                  <span
                    className={`badge badge-sm ${
                      request.status === 'paid' ? "bg-gradient-success" : request.status === "approved" ? "bg-gradient-primary" : request.status === "rejected" ? "bg-gradient-danger" : "bg-gradient-secondary"
                    }`}
                  >
                    {toTitleCase(request.status)}
                  </span>
                </td>
                <td className="align-middle text-center">
                  <p className="">
                    {moment(request.processedAt).format("MMMM Do, YYYY  h:mm A")}
                  </p>
                </td>
                <td className="align-middle text-center">
                  <div className="d-flex justify-content-center ">
                    {/* <Button style={{ background: '#6148a1', border: 'none' }} onClick={() => handelAprovedRequest(user)}></Button> */}
                    <Dropdown className="border-0 rounded-2 add-btn fw-bold">
                      <Dropdown.Toggle
                        className="border-0"
                        id="dropdown-basic"
                        aria-expanded="false"
                        style={{ backgroundColor: "#6148a1" }}
                      >
                        <button
                          type="button"
                          className="bg-transparent border-0 text-white"
                          data-bs-toggle="button"
                        >
                          <spam className="d-inline postition-relative text-white">
                            Take Action
                          </spam>
                        </button>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="w-100 text-center">
                        <Dropdown.Item
                          eventKey="1"
                          onClick={() => setDetPopup({type: true, index: index})}
                          style={{ fontSize: 13 }}
                        >
                          View
                        </Dropdown.Item>
                        {request.status === 'approved' &&
                        <Dropdown.Item
                          eventKey="1"
                          onClick={() => markPaid(request?._id)}
                          style={{ fontSize: 13 }}
                        >
                          Mark as Paid
                        </Dropdown.Item>
                        }{request.status === 'pending' &&
                        <Dropdown.Item
                          eventKey="2"
                          onClick={() => ApprovePayment(request?._id)}
                          style={{ fontSize: 13 }}
                        >
                          Approve
                        </Dropdown.Item>}
                        {request.status !== 'paid' &&
                        <Dropdown.Item
                          eventKey="2"
                          onClick={() => RejectPayment(request?._id)}
                          style={{ fontSize: 13 }}
                        >
                          Reject    
                        </Dropdown.Item>}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </td>
              </tr>
            </tbody>
          ));

  const pageCount = Math.ceil(searchData().length / PER_PAGE);

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <div
            className="spinner-border"
            role="status"
            style={{ width: "6rem", height: "6rem", color: "#6148A1" }}
          >
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          <div className="container-fluid ">
            <div className="row">
              <div className="col-12">
                <div className="card mb-4">
                  <div className="card-header pb-0">
                    <h6>Payment Withdrawal Requests </h6>
                  </div>
                  <div
                    className="card-body px-0 pt-0 pb-2 task"
                    style={{ height: "73vh", overflow: "auto" }}
                  >
                    <div className="table-responsive p-0">
                      <table className="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th className="text-uppercase">User</th>
                            <th className="text-uppercase">Withdrawable</th>
                            <th className="text-uppercase">Locked Already</th>
                            <th className="text-uppercase">Rq. Amount</th>
                            <th className="">
                              <Dropdown className="">
                                <Dropdown.Toggle
                                  className=" border-0"
                                  variant=""
                                  id="dropdown-basic"
                                  aria-expanded="false"
                                >
                                  <span
                                    className="fs-6 fw-bold text-uppercase"
                                    style={{ color: "#67748e" }}
                                  >
                                    Status{" "}
                                    <BsCaretDownFill size={12}/>
                                  </span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="dropdown-menu">
                                <Dropdown.Item
                                  onClick={() => {
                                    setQ("");
                                  }}
                                >
                                  <span className="fw-bold">
                                    All Requests
                                  </span>
                                </Dropdown.Item>
                                  {
                                    list.map((e) =>{
                                      return(
                                          <Dropdown.Item
                                          onClick={() => {
                                            setQ(e);
                                          }}
                                        >
                                          <span className="fw-bold">
                                            {e}
                                          </span>
                                        </Dropdown.Item>
                                      )
                                    })
                                  }
                                </Dropdown.Menu>
                              </Dropdown>
                            </th>
                            <th className=" text-uppercase ps-5">
                              Last Processed
                            </th>
                            <th className="text-uppercase text-center">
                              Actions
                            </th>
                          </tr>
                        </thead>
                        {currentPageData}
                      </table>
                    </div>

                    {searchData().length > 24 ? (
                      <div
                        className=" mt-4"
                        style={{
                          padding: 2,
                          boxSizing: "border-box",
                          width: "100%",
                        }}
                      >
                        <ReactPaginate
                          activeClassName={"item active "}
                          breakClassName={"item break-me "}
                          breakLabel={"..."}
                          containerClassName={"pagination"}
                          t
                          disabledClassName={"disabled-page"}
                          marginPagesDisplayed={2}
                          nextClassName={"item next "}
                          nextLabel={
                            <MdOutlineNavigateNext
                              style={{ fontSize: 18, width: 150 }}
                            />
                          }
                          onPageChange={handlePageClick}
                          pageCount={pageCount}
                          pageClassName={"item pagination-page "}
                          pageRangeDisplayed={2}
                          previousClassName={"item previous"}
                          previousLabel={
                            <GrFormPrevious
                              style={{ fontSize: 18, width: 150 }}
                            />
                          }
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Modal
            show={LikesPopup.type}
            onHide={() => setDetPopup({type: false, index: null})}
            backdrop="static"
            keyboard={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title style={{fontSize: 20}}>Banking Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="d-flex justify-content-center ">
                <div className="d-flex flex-column" style={{minWidth: 240}}>
                  <p className="text-dark" style={{}}>Account Holder's Name:</p>
                  <p className="text-dark" style={{}}>Bank Name:</p>
                  <p className="text-dark" style={{}}>Account Number:</p>
                  <p className="text-dark" style={{}}>IBAN Number:</p>
                  <p className="text-dark" style={{}}>SWIFT Code:</p>
                </div>
                <div className="d-flex flex-column">
                  <p className="text-dark fs-6">{Data[LikesPopup.index]?.bankDetails?.accountHolderName.toUpperCase()}</p>
                  <p className="text-dark fs-6">{Data[LikesPopup.index]?.bankDetails?.bankName}</p>
                  <p className="text-dark fs-6">{Data[LikesPopup.index]?.bankDetails?.accountNumber}</p>
                  <p className="text-dark fs-6">{Data[LikesPopup.index]?.bankDetails?.iban?Data[LikesPopup.index]?.bankDetails?.iban : `(Not Available)`}</p>
                  <p className="text-dark fs-6">{Data[LikesPopup.index]?.bankDetails?.swiftCode? Data[LikesPopup.index]?.bankDetails?.swiftCode : `(Not Available)` }</p>
                </div>
              </div>
            </Modal.Body>
            {/* <Modal.Footer>
              <Button variant="secondary" onClick={reportPost()}>
                Submit
              </Button>
            </Modal.Footer> */}
          </Modal>
        </>
      )}
    </>
  );
};

export default SellerWithdraws;
